import { useState, useCallback, useRef } from 'react';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 列ヘッダー埋め込みのドロップダウンフィルター。ボタンクリックで絶対座標ポップオーバーを表示し、選択値を親へコールバック
 * @graph-connects none
 */
export function DropdownFilter({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: { key: string; display: string }[];
  value: string;
  onChange: (v: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement>(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const isActive = value !== 'all';

  const handleOpen = useCallback(() => {
    if (btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 4, left: rect.left });
    }
    setOpen((v) => !v);
  }, []);

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        className={`inline-flex items-center gap-1 hover:text-[var(--color-text-primary)] transition-colors ${isActive ? 'text-[var(--color-accent-primary)]' : ''}`}
        onClick={handleOpen}
      >
        {label}
        <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none">
          <path d="M3 5L6 8L9 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
      {open && (
        <>
          <div
            className="fixed inset-0 z-[100]"
            onClick={() => {
              setOpen(false);
            }}
          />
          <div
            className="fixed z-[101] bg-[var(--color-bg-elevated)] border border-[var(--color-border)] rounded-lg shadow-lg py-1 min-w-[130px] max-h-[240px] overflow-y-auto"
            style={{ top: pos.top, left: pos.left }}
          >
            {options.map((opt) => (
              <button
                key={opt.key}
                type="button"
                className={`block w-full text-left px-3 py-1.5 text-xs hover:bg-[var(--color-bg-hover)] whitespace-nowrap ${value === opt.key ? 'text-[var(--color-accent-primary)] font-medium' : 'text-[var(--color-text-primary)]'}`}
                onClick={() => {
                  onChange(opt.key);
                  setOpen(false);
                }}
              >
                {opt.display}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
}
